export const associationReducer = (state, {type, payload}) => {
    switch (type) {
        case "initAssociationSurroundingList":
            return payload;
        case "addSurrounding":
            return [
                ...state,
                payload //new Surrounding
            ];
        case "removeSurrounding":
            return [
                ...state.filter((surrounding) => surrounding.email !== payload) //payload == surroundingId
            ];
        default:
            return state;
    }
}
